<template>
  <div id="app">
    <template v-if="keepAlive">
      <teleport to="body">
        <router-view />
      </teleport>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      keepAlive: true
    }
  },
  watch: {
    $route (to) {
      if (to.meta.keepAlive) {
        this.keepAlive = true
      } else {
        this.keepAlive = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #F5F7FA;
  overflow-y: scroll;
  box-sizing: border-box;
}
</style>
